import React from "react";
import { useParams, useHistory } from "react-router-dom";
import { FrameContext } from "../../contexts/FrameContext";
import firebaseApi from "../../apis/firebaseApi";
import dateHelpers from "../../helpers/dateHelpers";
import useTranslations from "../../hooks/useTranslations";
import useScheduleDay from "../../hooks/useScheduleDay";

const AppointmentConfirm = () => {
    const { scheduleId } = useParams();
    const { companyId, isInFrame, sendMessage, settings } = React.useContext(FrameContext);
    const [schedule, setSchedule] = React.useState();
    let history = useHistory();

    let content = useTranslations();

    React.useEffect(() => {
        if (!companyId || !scheduleId) return;
        firebaseApi.getAgentSchedule(companyId, scheduleId, data => {
            if (data.empty) {
                history.push(`/agent`);
            }
            setSchedule({ ...data.data(), id: data.id })
        });
    }, [companyId, scheduleId]);

    const onCloseWindowClick = () => {
        sendMessage("scheduling_complete", schedule);
    }

    const getButtonStyles = () => {
        if (!settings || !settings.styles || (!settings.styles.buttonBorderRadius && !settings.styles.successColor)) return null;

        let styles = {};
        if (settings.styles.buttonBorderRadius) {
            styles.borderRadius = settings.styles.buttonBorderRadius;
        }

        if (settings.styles.primaryColor) {
            styles.backgroundColor = settings.styles.primaryColor;
        }

        if (settings.styles.secondaryTextColor) {
            styles.color = settings.styles.secondaryTextColor;
        }

        return styles;
    }

    let scheduleDay = useScheduleDay(schedule ? new Date(schedule.schedule.startTime * 1000) : null);

    if (!schedule) return null;

    return (
        <div className="cts-scheduled">
            <h2>
                {content.common.scheduleAppointmentHeader}
                {content.common.scheduleAppointmentHeader2 ? <><br/>{content.common.scheduleAppointmentHeader2}</> : null}
            </h2>
            {content.confirmAppointment.header && <h3>{content.confirmAppointment.header}</h3>}
            <div className="cts-email-text">
                {content.confirmAppointment.confirm.replace("{name}", schedule.name)}
            </div>
            <hr />
            <div className="cts-schedule-date-container">
                <div className="cts-calendar-container">
                    <i className="fas fa-calendar-star" />
                </div>
                <div className="cts-date-container">
                    <b>{scheduleDay}</b><br />
                    {dateHelpers.getTimeString(new Date(schedule.schedule.startTime * 1000))} - {dateHelpers.getTimeString(new Date(schedule.schedule.endTime * 1000), true)}
                </div>
            </div>
            <hr />
            {/* <div className="cts-schedule-buttons">
                <button type="button" className="btn btn-black"><i className="far fa-plus" /> Add to Calendar</button>
                <div className="cts-split">
                    <button type="button" onClick={onRescheduleClick} className="btn-secondary">Reschedule</button>
                    <button type="button" onClick={onCancelClick} className="btn-secondary">Cancel Now</button>
                </div>
            </div> */}
            {
                (content.confirmAppointment.email || content.confirmAppointment.email2) &&
                <>
                    <div className="cts-email-text">
                        {content.confirmAppointment.email}
                    </div>
                    <div className="cts-email-text">
                        {content.confirmAppointment.email2}
                    </div>
                </>
            }

            {
                isInFrame() &&
                <div className="cts-footer-btn">
                    <button style={getButtonStyles()} onClick={onCloseWindowClick} type="button">{content.common.closeWindow}</button>
                </div>
            }

        </div>
    )
}

export default AppointmentConfirm;